/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Stat_Domain_Rating_ByInputs */

const en_directory_home_hero_stat_domain_rating_by = /** @type {(inputs: Directory_Home_Hero_Stat_Domain_Rating_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by Ahrefs`)
};

const zh_directory_home_hero_stat_domain_rating_by = /** @type {(inputs: Directory_Home_Hero_Stat_Domain_Rating_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自 Ahrefs`)
};

/**
* | output |
* | --- |
* | "by Ahrefs" |
*
* @param {Directory_Home_Hero_Stat_Domain_Rating_ByInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_stat_domain_rating_by = /** @type {((inputs?: Directory_Home_Hero_Stat_Domain_Rating_ByInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Stat_Domain_Rating_ByInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_stat_domain_rating_by(inputs)
	return zh_directory_home_hero_stat_domain_rating_by(inputs)
});
export { directory_home_hero_stat_domain_rating_by as "directory.home.hero.stat_domain_rating_by" }